<template>
  <div id="accessRequest">
    <h2 class="text-center">Please fill out the below form</h2>
    <validation-observer ref="observer" v-slot="{ invalid }" tag="form">
      <b-container>
        <b-form @submit.stop.prevent="onSubmit">
          <b-row>
            <b-col>
              <validation-provider name="user name" rules="required" v-slot="{ errors }">
                <b-form-group id="userGroup" label="Desired User Name:" label-for="userInput">
                  <b-form-input id="userInput" type="text" v-model="form.username"/>
                  <span class="text-danger">{{errors[0]}}</span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!-- a hack, probably -->
            <b-col></b-col>
          </b-row>

          <b-row>
            <b-col>
              <validation-provider name="first name" rules="required" v-slot="{ errors }">
                <b-form-group id="firstNameGroup" label="First Name:" label-for="firstNameInput">
                  <b-form-input id="firstNameInput" type="text" v-model="form.given_name"/>
                  <span class="text-danger">{{errors[0]}}</span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col>
              <validation-provider name="last name" rules="required" v-slot="{ errors }">
                <b-form-group id="lastNameGroup" label="Last Name:" label-for="lastNameInput">
                  <b-form-input id="lastNameInput" type="text" v-model="form.family_name"/>
                  <span class="text-danger">{{errors[0]}}</span>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <validation-provider name="email address" rules="required|email" v-slot="{ errors }">
                <b-form-group id="emailGroup" label="Email Address:" label-for="emailAddress">
                  <b-form-input id="emailInput" type="text" v-model="form.email"/>
                  <span class="text-danger">{{errors[0]}}</span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col>
              <validation-provider name="phone number" rules="required|digits:10" v-slot="{ errors }">
                <b-form-group id="phoneGroup" label="Phone Number:" label-for="phoneInput">
                  <b-input-group>
                    <b-form-input id="phoneInput" type="text" v-model="form.phone_number"/>
                    <b-input-group-append>
                      <a href="#" id="phoneInfo"><img src="../assets/question.png" alt="question mark"/></a>
                    </b-input-group-append>
                  </b-input-group>
                  <span class="text-danger">{{errors[0]}}</span>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <validation-provider name="password"
                                   :rules="{required: true, regex: /^(?=.{10,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).+$/ }"
                                   vid="pass" v-slot="{ errors }">
                <b-form-group id="passwordGroup" label="Password:" label-for="passInput">
                  <b-input-group>
                    <b-input id="passInput" type="password" v-model="form.pass"/>
                    <b-input-group-append><a href="#" id="passwordInfo"><img src="../assets/question.png"
                                                                             alt="password question mark"/></a>
                    </b-input-group-append>
                  </b-input-group>
                  <span class="text-danger">{{errors[0]}}</span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col>
              <validation-provider name="password confirmation" rules="required|passwordConfirm:pass"
                                   v-slot="{ errors }">
                <b-form-group id="passwordConfirmGroup" label="Confirm Password:" label-for="confirmInput">
                  <b-input id="confirmInput" type="password" v-model="form.confirmPass"/>
                  <span class="text-danger">{{errors[0]}}</span>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-form-group id="consentGroup">
                <b-form-checkbox id="smsContact" v-model="form.smsContact" value="true" unchecked-value="false">I wish
                  to receive SMS messages from Apoplectic.net
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

          <b-button class="mr-2" type="submit" variant="outline-danger">Submit</b-button>
          <b-button class="mr-2" type="reset" variant="outline-danger">Clear Fields</b-button>
          <b-button variant="outline-danger" @click="$router.push('/')">Back to login</b-button>
        </b-form>
      </b-container>
    </validation-observer>

    <b-modal id="confirmInfoModal"
             title="Confirm User Info"
             v-model="modalShow"
             header-bg-variant="secondary"
             header-class="default-color"
             body-bg-variant='dark'
             ok-variant="outline-danger"
             cancel-variant="outline-danger"
             footer-bg-variant="dark"
             @ok="confirmedSubmit">
      <b-container id="confirmDiv" class="default-color">
        <p>Desired Username: {{this.form.username}}</p>
        <p>Name: {{this.form.given_name}} {{this.form.family_name}}</p>
        <p>Email Address: {{this.form.email}}</p>
        <p>Phone Number: {{this.form.phone_number}}</p>
      </b-container>
    </b-modal>

    <b-popover target="phoneInfo" triggers="hover" variant="danger">
      <p>We use phone numbers for confirming accounts and sending event reminders if you opt-in to receive those
        messages.</p>
      <p>We will never share your phone number with 3rd parties.</p>
      <p>Only US phone numbers are supported at this time.</p>
    </b-popover>

    <b-popover target="passwordInfo" triggers="hover" variant="danger">
      <template v-slot:title>Password Requirements</template>
      <ul>
        <li>At least 1 lower case and 1 upper case letter</li>
        <li>At least 1 digit</li>
        <li>At least 1 of the following special characters<br/>!@#$%^&*</li>
        <li>Minimum length of 10 characters</li>
      </ul>
    </b-popover>
  </div>
</template>

<script>
  import { Auth } from 'aws-amplify'

  export default {
    name: 'AccessRequest',
    data () {
      return {
        form: {
          username: '',
          pass: '',
          given_name: '',
          family_name: '',
          email: '',
          phone_number: '',
          confirmPass: '',
          smsContact: 'false'
        },
        modalShow: false
      }
    },
    methods: {
      onSubmit (e) {
        e.preventDefault()
        this.$refs.observer.validate().then((result) => {
          if (!result) {
            return
          }
          this.modalShow = true
        })
      },
      confirmedSubmit () {
        Auth.signUp({
          username: this.form.username,
          password: this.form.pass,
          attributes: {
            email: this.form.email,
            given_name: this.form.given_name,
            family_name: this.form.family_name,
            name: this.form.given_name + ' ' + this.form.family_name,
            phone_number: '+1' + this.form.phone_number
          },
          validationData: [],
        })
          .then(
            data => {
              this.user = data.user
              this.$router.push('unconfirmed')
            })
          .catch(err => console.log(err))
      }
    }
  }

</script>
